import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0947eff3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"border-radius":"1rem"} }
const _hoisted_2 = {
  key: 0,
  class: "w-full border shadow-lg text-gray-800 border-primary-50 dark:text-dark-text dark:bg-dark-400 dark:border-dark-400 border-separate border-spacing-0",
  style: {"border-radius":"1rem"}
}
const _hoisted_3 = { class: "w-full text-white" }
const _hoisted_4 = { class: "grid grid-cols-8 text-sm" }
const _hoisted_5 = {
  class: "border-r py-2 flex justify-center items-center bg-primary border-primary-400 dark:border-dark-400 dark:bg-dark-400",
  style: {"border-radius":"1rem 0 0 0"}
}
const _hoisted_6 = { class: "border-r flex justify-center items-center bg-primary border-primary-400 dark:border-dark-400 dark:bg-dark-400" }
const _hoisted_7 = { class: "border-r flex justify-center items-center bg-primary border-primary-400 dark:border-dark-400 dark:bg-dark-400" }
const _hoisted_8 = { class: "border-r flex justify-center items-center bg-primary border-primary-400 dark:border-dark-400 dark:bg-dark-400" }
const _hoisted_9 = { class: "border-r flex justify-center items-center bg-primary border-primary-400 dark:border-dark-400 dark:bg-dark-400" }
const _hoisted_10 = { class: "border-r flex justify-center items-center bg-primary border-primary-400 dark:border-dark-400 dark:bg-dark-400" }
const _hoisted_11 = { class: "border-r flex justify-center items-center bg-primary border-primary-400 dark:border-dark-400 dark:bg-dark-400" }
const _hoisted_12 = {
  class: "flex justify-center items-center bg-primary border-primary-400 dark:border-dark-400 dark:bg-dark-400",
  style: {"border-radius":"0 1rem 0 0"}
}
const _hoisted_13 = {
  class: "border-l border-r border-primary-50 dark:border-dark-400",
  style: {"border-radius":"1rem"}
}
const _hoisted_14 = { class: "grid grid-cols-8" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "text-gray-600"
}
const _hoisted_17 = {
  class: "mx-2",
  style: {"overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap","text-align":"center"}
}
const _hoisted_18 = ["data-tooltip", "onClick"]
const _hoisted_19 = {
  key: 1,
  class: "material-icons"
}
const _hoisted_20 = {
  key: 0,
  class: "dark:bg-dark-500",
  style: {"border-radius":"0 0 1rem 1rem"}
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "grid grid-cols-2" }
const _hoisted_23 = { class: "mx-6 mt-3" }
const _hoisted_24 = { class: "mx-6 mt-3" }
const _hoisted_25 = { class: "grid grid-cols-2" }
const _hoisted_26 = { class: "flex justify-center testCaseText" }
const _hoisted_27 = { class: "flex justify-center testCaseText" }
const _hoisted_28 = { class: "grid grid-cols-2" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, " file_download ", -1))
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "file_download", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_judge_badge = _resolveComponent("judge-badge")!
  const _component_input_area = _resolveComponent("input-area")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.testcases.length > 0)
      ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
          _createElementVNode("thead", _hoisted_3, [
            _createElementVNode("tr", _hoisted_4, [
              _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('message.case')), 1),
              _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('message.status')), 1),
              _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('message.time')), 1),
              _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('message.memory')), 1),
              _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('message.input')), 1),
              _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('message.output')), 1),
              _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('message.caseName')), 1),
              _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('message.casePaste')), 1)
            ])
          ]),
          _createElementVNode("tbody", _hoisted_13, [
            _createVNode(_TransitionGroup, {
              appear: "",
              name: "table-row"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testcases, (tc, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: tc.serial,
                    class: "grid",
                    style: _normalizeStyle(`--delay-time: ${index * 100}ms`)
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("td", {
                        class: _normalizeClass(["border-r border-t flex justify-center border-primary-50 dark:border-dark-400 dark:bg-dark-500", _ctx.isHideJudgeCaseList[index] ? 'border-b' : '']),
                        style: _normalizeStyle(
                  !_ctx.isHideJudgeCaseList[index] && index == _ctx.testcases.length - 1 ? { borderRadius: '0 0 0 1rem' } : {}
                )
                      }, [
                        _createElementVNode("button", {
                          class: "text-blue-500 focus:outline-none hover:underline",
                          onClick: ($event: any) => (_ctx.clickJudgeCase(index))
                        }, _toDisplayString(tc.label), 9, _hoisted_15)
                      ], 6),
                      _createElementVNode("td", {
                        class: _normalizeClass(["border-r border-t flex justify-center items-center p-1 border-primary-50 dark:border-dark-400 dark:bg-dark-500", _ctx.isHideJudgeCaseList[index] ? 'border-b' : ''])
                      }, [
                        (!tc.status)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, " - "))
                          : (_openBlock(), _createBlock(_component_judge_badge, {
                              key: 1,
                              status: _ctx.status(tc.status)
                            }, null, 8, ["status"]))
                      ], 2),
                      _createElementVNode("td", {
                        class: _normalizeClass(["border-r border-t flex justify-center items-center text-center p-1 border-primary-50 dark:border-dark-400 dark:bg-dark-500", _ctx.isHideJudgeCaseList[index] ? 'border-b' : ''])
                      }, _toDisplayString(tc.cpuTime == null ? '' : (tc.cpuTime / 100).toFixed(2)) + " sec ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(["border-r border-t flex justify-center items-center p-1 text-center border-primary-50 dark:border-dark-400 dark:bg-dark-500", _ctx.isHideJudgeCaseList[index] ? 'border-b' : ''])
                      }, _toDisplayString(tc.memory) + " KB ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(["border-r border-t flex justify-center items-center p-1 text-center border-primary-50 dark:border-dark-400 dark:bg-dark-500", _ctx.isHideJudgeCaseList[index] ? 'border-b' : ''])
                      }, _toDisplayString(tc.inputSize) + " B ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(["border-r border-t flex justify-center items-center p-1 text-center border-primary-50 dark:border-dark-400 dark:bg-dark-500", _ctx.isHideJudgeCaseList[index] ? 'border-b' : ''])
                      }, _toDisplayString(tc.outputSize) + " B ", 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(["flex justify-center items-center border-r border-t p-1 text-center border-primary-50 dark:border-dark-400 dark:bg-dark-500", _ctx.isHideJudgeCaseList[index] ? 'border-b' : ''])
                      }, [
                        _createElementVNode("p", _hoisted_17, _toDisplayString(tc.caseName), 1)
                      ], 2),
                      _createElementVNode("td", {
                        class: _normalizeClass(["justify-center flex border-t p-1 border-primary-50 dark:border-dark-400 dark:bg-dark-500", _ctx.isHideJudgeCaseList[index] ? 'border-b' : '']),
                        style: _normalizeStyle(
                  !_ctx.isHideJudgeCaseList[index] && index == _ctx.testcases.length - 1 ? { borderRadius: '0 0 1rem 0' } : {}
                )
                      }, [
                        (
                    (_ctx.judgeCaseList[index].in != 'It\'s large data. Please download it.' &&
                      _ctx.judgeCaseList[index].in != 'JudgeCase is not available.') ||
                    (_ctx.judgeCaseList[index].out != 'It\'s large data. Please download it.' &&
                      _ctx.judgeCaseList[index].out != 'JudgeCase is not available.')
                  )
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "material-icons focus:outline-none hover:text-blue-500",
                              "data-tooltip": _ctx.$t('message.pasted'),
                              onClick: ($event: any) => (_ctx.pasteCase(index))
                            }, " content_paste ", 8, _hoisted_18))
                          : (_openBlock(), _createElementBlock("span", _hoisted_19, " clear "))
                      ], 6)
                    ]),
                    (_ctx.judgeCaseList)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          (_ctx.isHideJudgeCaseList[index])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('message.input')), 1),
                                  _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('message.output')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_25, [
                                  _createElementVNode("td", _hoisted_26, [
                                    _createVNode(_component_input_area, {
                                      id: "user-input",
                                      class: "mt-2 rounded border border-gray-300 bg-gray-200 text-gray-800 dark:border-dark-200 dark:bg-dark-400 dark:text-dark-text",
                                      isEditable: false,
                                      value: _ctx.judgeCaseList[index].in
                                    }, null, 8, ["value"])
                                  ]),
                                  _createElementVNode("td", _hoisted_27, [
                                    _createVNode(_component_input_area, {
                                      id: "expected-output",
                                      class: "mt-2 rounded border border-gray-300 bg-gray-200 text-gray-800 dark:border-dark-200 dark:bg-dark-400 dark:text-dark-text",
                                      isEditable: false,
                                      value: _ctx.judgeCaseList[index].out
                                    }, null, 8, ["value"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("button", {
                                    class: "copyButton text-sm border flex items-center justify-center rounded py-1 pr-2 transform duration-150 focus:outline-none",
                                    style: {"width":"130px"},
                                    onClick: ($event: any) => (_ctx.clickDownload(index, false))
                                  }, [
                                    _hoisted_30,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.download')), 1)
                                  ], 8, _hoisted_29),
                                  _createElementVNode("button", {
                                    class: "copyButton text-sm border flex items-center justify-center rounded py-1 pr-2 transform duration-150 focus:outline-none",
                                    style: {"width":"130px"},
                                    onClick: ($event: any) => (_ctx.clickDownload(index, true))
                                  }, [
                                    _hoisted_32,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.download')), 1)
                                  ], 8, _hoisted_31)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 4))
                }), 128))
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}